import { render, staticRenderFns } from "./CoherentWaveInterferenceViz.vue?vue&type=template&id=f94ed3e8&scoped=true"
import script from "./CoherentWaveInterferenceViz.vue?vue&type=script&lang=js"
export * from "./CoherentWaveInterferenceViz.vue?vue&type=script&lang=js"
import style0 from "./CoherentWaveInterferenceViz.vue?vue&type=style&index=0&id=f94ed3e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94ed3e8",
  null
  
)

export default component.exports